import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate, Link } from 'react-router-dom';
import paymentService from '../../services/paymentService';
import LoadingSpinner from '../UI/LoadingSpinner';
import './PaymentSuccess.css';
import { useSearchParams } from 'react-router-dom';
import sbiQueries from '../../queries/sbiQueries';
import siteQueries from '../../queries/siteQueries';

const PaymentSuccess = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [paymentDetails, setPaymentDetails] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [searchParams] = useSearchParams();
  const [callbackStatus, setCallbackStatus] = useState('pending');
  const [paymentData, setPaymentData] = useState(null);


  useEffect(() => {
    const handlePaymentCallback = async () => {
         const currentUrl = window.location.href.replace(/&amp;/g, '&');
         const url = new URL(currentUrl)
         const urlParams = new URLSearchParams(url.search);
         const orderId =  urlParams.get('orderId');
         const reactCallback = urlParams.get('reactCallback');
         const amount = urlParams.get('amount');
         const transactionId = urlParams.get('transactionId');
         const status = urlParams.get('status');
       // Set initial payment details from URL
        const initialDetails = {
           orderId,
           amount: parseFloat(amount) || 0,
           transactionId,
           status,
           timestamp: new Date().toISOString()
         };

         setPaymentDetails(initialDetails);

      // Only handle callback if reactCallback flag is present
      if (reactCallback === 'true' && orderId) {
        try {
          // Step 1: Get payment status
          const statusResponse = await fetch('https://keralasahityaakademi.org/sbiepay-php/public/api/payment/status.php', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({ orderId }),
          });

          const statusData = await statusResponse.json();

          if (statusData.success && statusData.status === 'success') {
            setPaymentData(statusData);

            // Step 2: Trigger callback to Node.js backend
            updatepayment.mutateAsync({
              paymentResponse: statusData.paymentResponse,
              originalPaymentData: statusData.originalPaymentData,
              status: 'success',
            });

          } else {
            setCallbackStatus('failed');
          }
        } catch (error) {
          console.error('Payment callback error:', error);
          setCallbackStatus('failed');
        }
      }
    };

    handlePaymentCallback();
  }, [searchParams]);
    

    const updatepayment = sbiQueries.useUpdatePayment(
    async (response) => {

      if(response?.success){
        setCallbackStatus('success');
        
        const qrcode = await qrCreate.mutateAsync({ 
            id: response?.userId
        });
        // Store QR data in session storage
        sessionStorage.setItem('qrdata', JSON.stringify(qrcode));
        // Navigate to success page
        setLoading(false);
        navigate('/atsuccess');  
        console.log("Registration successful");      
      }
        
    },
    {
      onError: (error) => {
        setCallbackStatus('failed');
        setError('Failed to update payment');
        setLoading(false);
      }
    }
  );



  const handleDownloadReceipt = async () => {
    if (!paymentDetails) return;

    try {
      // Create a simple receipt
      const receiptContent = `
        PAYMENT RECEIPT
        ===============
        
        Order ID: ${paymentDetails.orderId}
        Transaction ID: ${paymentDetails.transactionId || 'N/A'}
        Amount: ${paymentService.formatCurrency(paymentDetails.amount)}
        Status: ${paymentDetails.status}
        Date: ${new Date(paymentDetails.completedAt || paymentDetails.timestamp).toLocaleString()}
        
        Customer Details:
        Email: ${paymentDetails.customerEmail || 'N/A'}
        Phone: ${paymentDetails.customerPhone || 'N/A'}
        
        Thank you for your payment!
      `;

      const blob = new Blob([receiptContent], { type: 'text/plain' });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `receipt-${paymentDetails.orderId}.txt`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error('Receipt download error:', error);
    }
  };

  const handleContinueShopping = () => {
    navigate('/');
  };

  const handleViewPayments = () => {
    navigate('/payments/history');
  };


  const qrCreate = siteQueries.useQrcreateMutation(async (response) => {
  });

  if (loading) {
    return (
      <div className="payment-success-container">
        <div className="payment-success-card">
          <LoadingSpinner />
          <p>Processing payment confirmation...</p>
        </div> 
      </div>
    );
  }

  if (error) {
    return (
      <div className="payment-success-container">
        <div className="payment-success-card error">
          <div className="error-icon">❌</div>
          <h1>Error</h1>
          <p>{error}</p>
          <div className="actions">
            <button onClick={() => navigate('/')} className="btn btn-primary">
              Go to Home
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="payment-success-container">
      <div className="payment-success-card">
        {/* Success Animation */}
        <div className="success-animation">
          <div className="checkmark-circle">
            <div className="checkmark">✓</div>
          </div>
        </div>

        {/* Success Message */}
        <div className="success-content">
          <h1>Payment Successful!</h1>
          <p className="success-message">
            Thank you! Your payment has been processed successfully.
          </p>
        </div>

        {/* Payment Details */}
        <div className="payment-details">
          <h3>Payment Details</h3>
          <div className="details-grid">
            <div className="detail-item">
              <span className="label">Order ID:</span>
              <span className="value">{paymentDetails.orderId}</span>
            </div>
            
            {paymentDetails.transactionId && (
              <div className="detail-item">
                <span className="label">Transaction ID:</span>
                <span className="value">{paymentDetails.transactionId}</span>
              </div>
            )}
            
            <div className="detail-item">
              <span className="label">Amount:</span>
              <span className="value amount">
                {paymentService.formatCurrency(paymentDetails.amount)}
              </span>
            </div>
            
            <div className="detail-item">
              <span className="label">Status:</span>
              <span className={`value status ${paymentDetails.status}`}>
              
                {paymentDetails.status?.toUpperCase()}
              </span>
            </div>
            
            <div className="detail-item">
              <span className="label">Date & Time:</span>
              <span className="value">
                {new Date(paymentDetails.completedAt || paymentDetails.timestamp).toLocaleString()}
              </span>
            </div>

            {paymentDetails.paymentMode && (
              <div className="detail-item">
                <span className="label">Payment Method:</span>
                <span className="value">{paymentDetails.paymentMode}</span>
              </div>
            )}

            {paymentDetails.description && (
              <div className="detail-item">
                <span className="label">Description:</span>
                <span className="value">{paymentDetails.description}</span>
              </div>
            )}
          </div>
        </div>

        {/* Customer Information */}
        {(paymentDetails.customerEmail || paymentDetails.customerPhone) && (
          <div className="customer-info">
            <h3>Customer Information</h3>
            <div className="details-grid">
              {paymentDetails.customerEmail && (
                <div className="detail-item">
                  <span className="label">Email:</span>
                  <span className="value">{paymentDetails.customerEmail}</span>
                </div>
              )}
              
              {paymentDetails.customerPhone && (
                <div className="detail-item">
                  <span className="label">Phone:</span>
                  <span className="value">{paymentDetails.customerPhone}</span>
                </div>
              )}
            </div>
          </div>
        )}

        {/* Action Buttons */}
        <div className="actions">
          <button 
            onClick={handleDownloadReceipt}
            className="btn btn-secondary"
          >
            📄 Download Receipt
          </button>
          
        
          
         
        </div>

        {/* Additional Information */}
        {/* <div className="additional-info">
          <div className="info-item">
            <div className="info-icon">📧</div>
            <div className="info-text">
              <strong>Email Confirmation</strong>
              <p>A confirmation email has been sent to your registered email address.</p>
            </div>
          </div>
          
          <div className="info-item">
            <div className="info-icon">🔒</div>
            <div className="info-text">
              <strong>Secure Transaction</strong>
              <p>Your payment was processed securely using industry-standard encryption.</p>
            </div>
          </div>
          
          <div className="info-item">
            <div className="info-icon">📞</div>
            <div className="info-text">
              <strong>Need Help?</strong>
              <p>Contact our support team if you have any questions about this transaction.</p>
            </div>
          </div>
        </div> */}

        {/* Footer */}
        <div className="success-footer">
          <p>
            Keep this confirmation for your records. 
            <Link to="/support" className="support-link">Contact Support</Link> if you need assistance.
          </p>
        </div>
      </div>
    </div>
  );
};

export default PaymentSuccess;